/**
 * GTD Processing Status - David Allen's workflow stages
 * Represents where an item is in the GTD clarification process
 */
export class ProcessingStatus {
  private constructor(private readonly value: 'new' | 'clarified' | 'processed') {}

  static new(): ProcessingStatus {
    return new ProcessingStatus('new');
  }

  static clarified(): ProcessingStatus {
    return new ProcessingStatus('clarified');
  }

  static processed(): ProcessingStatus {
    return new ProcessingStatus('processed');
  }

  isNew(): boolean {
    return this.value === 'new';
  }

  isClarified(): boolean {
    return this.value === 'clarified';
  }

  isProcessed(): boolean {
    return this.value === 'processed';
  }

  equals(other: ProcessingStatus): boolean {
    return this.value === other.value;
  }

  toString(): string {
    return this.value;
  }
}